import { CSSProperties } from '@material-ui/core/styles/withStyles';

// Headline
export const h1: CSSProperties = {
  fontSize: '54px',
  lineHeight: '72px',
};

export const h2: CSSProperties = {
  fontSize: '38px',
  lineHeight: '48px',
};

export const h3: CSSProperties = {
  fontSize: '30px',
  lineHeight: '42px',
};

export const h4: CSSProperties = {
  fontSize: '26px',
  lineHeight: '36px',
};

export const h5: CSSProperties = {
  fontSize: '18px',
  lineHeight: '24px',
};

export const h6: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
};

export const h7: CSSProperties = {
  fontSize: '12px',
  lineHeight: '18px',
};

/**
  @deprecated
*/
export const h8: CSSProperties = {
  fontSize: '13px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

// Text
export const textBig: CSSProperties = {
  fontSize: '18px',
  lineHeight: '24px',
};

export const textBigCompact: CSSProperties = {
  fontSize: '18px',
  lineHeight: '18px',
};

export const textRegular: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
};

export const textRegularCompact: CSSProperties = {
  fontSize: '16px',
  lineHeight: '18px',
};

export const textSmall: CSSProperties = {
  fontSize: '14px',
  lineHeight: '24px',
};

export const textSmallCompact: CSSProperties = {
  fontSize: '14px',
  lineHeight: '18px',
};

export const textTiny: CSSProperties = {
  fontSize: '12px',
  lineHeight: '18px',
  fontFamily: 'NotoSans-Regular',
};

export const textTinyCompact: CSSProperties = {
  fontSize: '12px',
  lineHeight: '12px',
};

// Accent
export const accentBig: CSSProperties = {
  fontSize: '18px',
  lineHeight: '24px',
};

export const accentBigCompact: CSSProperties = {
  fontSize: '18px',
  lineHeight: '28px',
  fontFamily: 'NotoSans-SemiBold',
};

export const accentRegular: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
};

export const accentRegularCompact: CSSProperties = {
  fontSize: '16px',
  lineHeight: '28px',
};

export const accentSmall: CSSProperties = {
  fontSize: '14px',
  lineHeight: '24px',
  fontFamily: 'NotoSans-SemiBold',
};

export const accentSmallCompact: CSSProperties = {
  fontSize: '14px',
  lineHeight: '18px',
};

export const accentTiny: CSSProperties = {
  fontSize: '12px',
  lineHeight: '18px',
};

export const accentTinyCompact: CSSProperties = {
  fontSize: '12px',
  lineHeight: '12px',
};

/**
  @deprecated
*/
export const bodyText: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'NotoSans-Regular',
  letterSpacing: 'normal',
};
/**
  @deprecated
*/
export const smallText: CSSProperties = {
  fontSize: '13px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Light',
  letterSpacing: 'normal',
};
/**
  @deprecated
*/
export const tinyText: CSSProperties = {
  fontSize: '12px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Light',
  letterSpacing: 'normal',
};
/**
  @deprecated
*/
export const labels: CSSProperties = {
  fontSize: '11px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Regular',
  textTransform: 'uppercase',
  letterSpacing: 'normal',
};
/**
  @deprecated
*/
export const siteNames: CSSProperties = {
  fontSize: '12px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Head',
  letterSpacing: 'normal',
};
/**
  @deprecated
*/
export const siteNamesMedium: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'e-Ukraine-Head',
  letterSpacing: 'normal',
};

export const monospace: CSSProperties = {
  fontFamily: 'RobotoMono-Regular',
};

/**
  @deprecated please choose h7 or another one
*/
export const subtitle1 = {
  fontSize: '16px',
  lineHeight: '24px',
};

/**
  @deprecated please choose bodyText or another one
*/
export const body1 = { // Body text
  fontSize: '16px',
  lineHeight: '24px',
};

/**
  @deprecated please choose smallText or another one
*/
export const body2 = { // Small text
  fontSize: '13px',
  lineHeight: '18px',
};
/**
  @deprecated please choose tinyText or another one
*/
export const caption = { // Tiny text
  fontSize: '12px',
  lineHeight: '16px',
};
